import { filterPresetApi } from "@/api/filterPreset";

const actions = {
  async create({ commit, dispatch, state }, preset) {
    await dispatch("list");

    const presetList = state.list;
    presetList.push(preset);

    await filterPresetApi.put(presetList);
    commit("setList", presetList);
  },
  async delete({ commit, state }, presetName) {
    const trimmedList = state.list.filter(item => item.name !== presetName);

    await filterPresetApi.put(trimmedList);
    commit("setList", trimmedList);
  },
  async list({ commit }) {
    const list = await filterPresetApi.get();

    commit("setList", list);
  },
};

const getters = {};

const mutations = {
  setList(state, list) {
    state.list = list;
  },
};

const state = {
  list: [],
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
